import _ from 'lodash'

export const requireOne = (required = []) => permissions => {
  if (_.isEmpty(required)) return true

  return !_.isEmpty(_.intersection(required, permissions))
}
